<template>
  <div class="login">
    <span>注册有乐中文网作者</span>
    <div class="register form">
      <el-form :model="regForm" :rules="rules" ref="ruleForm">
<!--        <el-form-item prop="uid">-->
<!--          <el-input prefix-icon="el-icon-notebook-2" placeholder="用户ID" v-model="regForm.uid"></el-input>-->
<!--        </el-form-item>-->
        <el-form-item prop="authorname">
          <el-input prefix-icon="el-icon-user" placeholder="作者名" v-model="regForm.authorname" @blur="handleAuthorNameBlur"></el-input>
        </el-form-item>
        <el-form-item prop="mobile">
          <el-input prefix-icon="el-icon-phone-outline" placeholder="电话" v-model="regForm.mobile"></el-input>
        </el-form-item>
        <el-form-item prop="qq">
          <el-input prefix-icon="el-icon-pear" placeholder="QQ" v-model="regForm.qq"></el-input>
        </el-form-item>
        <el-form-item prop="email">
          <el-input prefix-icon="el-icon-message" placeholder="电子邮箱" v-model="regForm.email"></el-input>
        </el-form-item>
        <el-form-item prop="channel" class="center">
          <el-radio-group v-model="regForm.channel">
            <el-radio label="1">男频</el-radio>
            <el-radio label="2">女频</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="center">
          <el-button type="primary" @click="submitForm('ruleForm')" :loading="is_reg">注册</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  // import {getQueryString} from "../../assets/js/util";
  import {applyForAuthor, checkAuthorName} from "../../assets/js/api/api";

  export default {
    data() {
      return {
        loginForm: {
          username: '',
          password: '',
        },
        regForm: {
          authorname: '',
          mobile: '',
          qq: '',
          email: '',
          channel: ''
        },
        rules: {
          authorname: [
            { required: true, message: '请输入作者名', trigger: 'blur' },
            { min:2, max:15, message: '长度在2到15个字符', trigger: 'blur'}
          ],
          mobile: [
            { required: true, message: '请输入电话', trigger: 'blur' },
          ],
          qq: [
            { required: true, message: '请输入QQ', trigger: 'blur' },
          ],
          email: [
            { required: true, message: '请输入邮箱', trigger: 'blur' },
            { type: 'email', message: '邮箱格式不正确', trigger: 'blur'}
          ],
          channel: [
            { required: true, message: '请选择频道', trigger: 'change' },
          ],
        },
        isForgetPwd: false,
        is_reg: false
      };
    },
    created () {
      // this.regForm.uid = getQueryString('uid');
    },
    methods: {
      // 验证作者名
      async handleAuthorNameBlur() {
        if (this.regForm.authorname !== '') {
          let res = await checkAuthorName({author_name: this.regForm.authorname});
          if (res.code === 1000) {
            return  true
          } else {
            this.$message.error(res.message)
          }
        }
      },
      // 注册
      submitForm(formName) {
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            this.is_reg = true;
            const {authorname, mobile, qq, email, channel} = this.regForm;
            let p = Object.assign({}, {author_name: authorname, qq, phone: mobile, email, sex_flag: channel});
            let res = await applyForAuthor(p);
            this.is_reg = false;
            if (res.code === 1000) {
              this.$message.success(res.message);
              window.location.href = '//www.iyoule.com/author.php';
            } else {
              this.$message.error(res.message)
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 重置表单
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  }
</script>

<style lang="less" scoped>
  .login {
    padding: 120px 0;
    margin: 0 auto;
    text-align: center;
    span {
      text-align: center;
      color: #ef4b4b;
      font-size: 2em;
      padding: 10px 0;
      border-bottom: 1px solid #ef4b4b;
    }
    .form {
      margin: 0 auto;
      background: #fff;
      border-radius: 4px;
    }
  }

  @media screen and (min-width: 768px){
    .form {
      width: 400px;
      padding: 40px 20px;
    }
  }
  @media screen and (max-width: 768px){
    .form {
      width: 100%;
      padding: 40px 0;
    }
  }

</style>
